import React from "react";
import { STUDIO } from "../data/site";
import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-cream border-t border-white/10 overflow-hidden">
      <div className="px-5 md:px-10 lg:px-16 pt-20 pb-8">
        <h2
          aria-hidden
          className="font-display font-black leading-[0.8] tracking-tighter text-cream"
          style={{ fontSize: "clamp(5rem, 22vw, 22rem)" }}
        >
          <span className="block">mat<span className="text-lime">r</span>aka<span className="text-hot">.</span></span>
        </h2>
      </div>
      <div className="border-t border-white/10 px-5 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <span className="font-body text-xs uppercase tracking-widest text-cream/60">
          © {new Date().getFullYear()} {STUDIO.name} Agency · Lisboa PT
        </span>
        <div className="flex gap-3">
          <a href={`mailto:${STUDIO.email}`} className="inline-flex items-center gap-2 font-body text-xs uppercase tracking-widest text-cream/60 hover:text-lime transition-colors"><Mail size={14}/>{STUDIO.email}</a>
          <span className="text-cream/20">·</span>
          <a href={`tel:${STUDIO.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 font-body text-xs uppercase tracking-widest text-cream/60 hover:text-lime transition-colors"><Phone size={14}/>{STUDIO.phone}</a>
          <span className="text-cream/20">·</span>
          <a href={STUDIO.instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-body text-xs uppercase tracking-widest text-cream/60 hover:text-lime transition-colors"><Instagram size={14}/>IG</a>
        </div>
      </div>
    </footer>
  );
}
